import React from 'react';
import { ITimeRangePicker } from './interfaces';
import { TimePicker } from '../TimePicker';
import { capitalizeStr } from '../../../helpers/stringHelpers';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';

export const TimeRangePicker: React.FC<ITimeRangePicker> = ({
  value,
  error,
  required,
  errorMessage,
  onChange,
  disabled,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" gap="10px">
      <TimePicker
        label={capitalizeStr(t('words.from'))}
        selectedTime={value.from}
        onChange={(time) =>
          onChange({
            from: time,
            to: value.to,
          })
        }
        maxTime={value.to || undefined}
        error={!!error?.start}
        disabled={disabled}
        required={required}
        errorMessage={errorMessage?.start}
      />
      <TimePicker
        label={capitalizeStr(t('words.to'))}
        selectedTime={value.to}
        onChange={(time) =>
          onChange({
            from: value.from,
            to: time,
          })
        }
        error={!!error?.end}
        disabled={disabled}
        minTime={value.from || undefined}
        required={required}
        errorMessage={errorMessage?.end}
      />
    </Stack>
  );
};
